export const tags = [
  { id: 1, name: "Design" },
  { id: 2, name: "Portfolio" },
  { id: 3, name: "Digital" },
  { id: 4, name: "Branding" },
  { id: 5, name: "Theme" },
  { id: 6, name: "Clean" },
  { id: 7, name: "UI & UX" },
  { id: 8, name: "Love" },
];
